module.exports = __webpack_public_path__ + "img/login-bg.11eec1b1.png";